jQuery(document).ready(function ($) {
	let menu_trap = false;
	let trap = false;

	$('.hamburger-menu').on('click', function () {
		$('.hamburger-menu').toggleClass('animate');
		$('body').toggleClass('mobile-menu-active');

		if ($('body').hasClass('mobile-menu-active')) {
			$('#mobile-menu').removeClass('invisible');

			$('html').css({
				height: '100vh',
				'overflow-y': 'hidden',
				position: 'fixed',
			});

			const focusTrap = require('focus-trap');

			//initialize the trap to focus on the mobile menu
			menu_trap = focusTrap.createFocusTrap(['header', '#mobile-menu']);

			//activate the trap
			menu_trap.activate();
		} else {
			$('html').css({
				height: '100%',
				'overflow-y': 'visible',
				position: 'relative',
			});

			if (menu_trap) {
				menu_trap.deactivate();
			}

			setTimeout(function () {
				$('#mobile-menu').addClass('invisible');
			}, 300);
		}

		closeMobileSubMenu();
	});

	$('#sub-menu-heading').on('click', function () {
		closeMobileSubMenu();
	});

	$('#mobile-menu ul > li.menu-item-has-children').on('click', function (e) {
		openMobileSubMenu(e, this);
	});

	$('#mobile-menu ul > li.menu-item-has-children a').on(
		'click',
		function (e) {
			openMobileSubMenu(
				e,
				$(this).parent(),
				$('body').hasClass('show-focus-outlines')
			);
		}
	);

	function openMobileSubMenu(e, $this, force_menu = false) {
		const focusTrap = require('focus-trap');

		//if the focus trap already exists
		if (trap) {
			//deactivate the trap
			trap.deactivate();

			//reset it
			trap = false;
		}

		//initialize the trap to focus on header and this sub-menu item
		trap = focusTrap.createFocusTrap([
			$('header')[0],
			$('#sub-menu-heading')[0],
			$($this)[0],
		]);

		//this calculates whether or not the user has clicked on the arrow to open a sub-menu
		let sub_menu_clicked = force_menu
			? true
			: e.pageX - $($this).parent().offset().left >
			  $($this).outerWidth() - 53;

		//if this menu is not currently open and the sub menu has been clicked (not the parent)
		if (!$('header').hasClass('mobile-menu-active') && sub_menu_clicked) {
			//prevent the link from proceeding
			e.preventDefault();

			//cancel out the loader
			$('#loader').removeClass('active');

			//add the classes
			$($this).addClass('sub-menu-active');
			$('header').addClass('mobile-menu-active');

			//activate the trap
			trap.activate();

			//focus on the heading button so the next tab is the correct link
			setTimeout(function () {
				$('#sub-menu-heading').focus();
			}, 300);
		} else if (
			!$('#mobile-menu ul > li.menu-item-has-children.sub-menu-active')
		) {
			//otherwise

			//remove the class
			$('header').removeClass('mobile-menu-active');

			//remove the trap
			trap.deactivate();

			//clear the trap
			trap = false;
		}
	}

	function closeMobileSubMenu() {
		$('header, #mobile-menu ul li').removeClass('mobile-menu-active');
		$('#mobile-menu ul > li.menu-item-has-children').removeClass(
			'sub-menu-active'
		);

		//if we have a trap that's currently active
		if (trap) {
			//remove the trap
			trap.deactivate();

			//clear the trap
			trap = false;
		}
	}

	let escape_mobile_menu = function (event) {
		//if the escape key is pressed
		if (event.key === 'Escape') {
			$('.hamburger-menu').removeClass('animate');
			$('body').removeClass('mobile-menu-active');

			$('html').css({
				height: '100%',
				'overflow-y': 'visible',
			});

			if (menu_trap) {
				menu_trap.deactivate();
			}

			setTimeout(function () {
				$('#mobile-menu').addClass('invisible');
			}, 300);

			closeMobileSubMenu();
		}
	};

	$('#mobile-menu').keydown(escape_mobile_menu);
	$('header').keydown(escape_mobile_menu);
});
